<template>
  <div>
    <drm-hotmart-integration
      v-if="integrationType === PLATFORMS.HOTMART"
      :selectedGroup="selectedGroup"
      :isEdit="isEdit"
    />
    <drm-eduzz-integration
      v-if="integrationType === PLATFORMS.EDUZZ"
      :selectedGroup="selectedGroup"
      :isEdit="isEdit"
    />
    <drm-xgrow-integration
      v-if="integrationType === PLATFORMS.XGROW"
      :selectedGroup="selectedGroup"
      :isEdit="isEdit"
    />
    <drm-the-members-integration
      v-if="integrationType === PLATFORMS.THE_MEMBERS"
      :selectedGroup="selectedGroup"
      :isEdit="isEdit"
    />
    <drm-ticto-integration
      v-if="integrationType === PLATFORMS.TICTO"
      :selectedGroup="selectedGroup"
      :isEdit="isEdit"
    />
    <drm-memberkit-integration
      v-if="integrationType === PLATFORMS.MEMBERKIT"
      :selectedGroup="selectedGroup"
      :isEdit="isEdit"
    />
    <drm-cademi-integration
      v-if="integrationType === PLATFORMS.CADEMI"
      :selectedGroup="selectedGroup"
      :isEdit="isEdit"
    />
    <drm-api-integration
      v-if="integrationType === PLATFORMS.API"
      :selectedGroup="selectedGroup"
      :isEdit="isEdit"
    />
  </div>
</template>

<script>
import DrmHotmartIntegration from './DrmIntegrations/DrmHotmartIntegration.vue'
import DrmTictoIntegration from './DrmIntegrations/DrmTictoIntegration.vue'
import DrmEduzzIntegration from './DrmIntegrations/DrmEduzzIntegration.vue'
import DrmXgrowIntegration from './DrmIntegrations/DrmXgrowIntegration.vue'
import DrmTheMembersIntegration from './DrmIntegrations/DrmTheMembersIntegration.vue'
import DrmMemberkitIntegration from './DrmIntegrations/DrmMemberkitIntegration.vue'
import DrmCademiIntegration from './DrmIntegrations/DrmCademiIntegration.vue'
import DrmApiIntegration from './DrmIntegrations/DrmApiIntegration.vue'

export default {
  name: 'DrmIntegrationFlow',
  components: {
    DrmHotmartIntegration,
    DrmTictoIntegration,
    DrmEduzzIntegration,
    DrmXgrowIntegration,
    DrmTheMembersIntegration,
    DrmMemberkitIntegration,
    DrmCademiIntegration,
    DrmApiIntegration,
  },
  data() {
    return {
      integrationType: '',
      selectedGroup: null,
      isEdit: false,
      PLATFORMS: {
        HOTMART: 'hotmart',
        EDUZZ: 'eduzz',
        XGROW: 'xgrow',
        THE_MEMBERS: 'the-members',
        TICTO: 'ticto',
        MEMBERKIT: 'memberkit',
        CADEMI: 'cademi',
        API: 'api',
      },
    }
  },
  mounted() {
    this.$root.$on('drmIntegrationFlowClose', () => {
      this.integrationType = null
    })
    console.log('DRM INTEGRATION FLOW')
    this.$root.$on('drmIntegrationFlow', (type, selectedGroup, isEdit) => {
      this.integrationType = type
      this.selectedGroup = selectedGroup
      this.isEdit = isEdit
    })
  },
  beforeDestroy() {
    this.$root.$off('drmIntegrationFlowClose')
    this.$root.$off('drmIntegrationFlow')
  },
}
</script>
